(function () {
  function slugify(text) {
    var value = String(text || '').trim().toLowerCase();
    if (value.normalize) value = value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    return value
      .replace(/[’']/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
  }

  function initGuidePage(page) {
    if (!page || page.dataset.sgGuideArticleReady === 'true') return;

    var article = page.querySelector('[data-sg-guide-article]');
    var toc = page.querySelector('[data-sg-guide-toc]');
    var list = page.querySelector('[data-sg-guide-toc-list]');
    if (!article || !toc || !list) return;

    // Always start from a clean, hidden state. This prevents an empty TOC shell
    // appearing if a guide does not qualify or the section is re-rendered.
    toc.hidden = true;
    list.innerHTML = '';

    var headings = Array.prototype.slice.call(article.querySelectorAll('h2'));

    // A useful contents list only needs three real sections. Do not use article
    // character count as a gate: several concise Street Garms guides have five
    // or more H2s but are intentionally under the previous 1,800-character limit.
    if (headings.length < 3) {
      page.dataset.sgGuideArticleReady = 'true';
      return;
    }

    var used = {};
    headings.forEach(function (heading) {
      var base = heading.id || slugify(heading.textContent);
      var id = base;
      var count = 2;
      while (used[id] || (document.getElementById(id) && document.getElementById(id) !== heading)) {
        id = base + '-' + count;
        count += 1;
      }
      used[id] = true;
      heading.id = id;

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    });

    toc.hidden = false;
    page.dataset.sgGuideArticleReady = 'true';
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-sg-guide-page]').forEach(initGuidePage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
